export default {"src":"/_next/static/media/compress-loading.8719cf5d.gif","height":557,"width":742};